import { range } from 'lodash-es'

export default function Sitemaps({ initData }) {
  const t = useI18n()
  const { type, pageCount, links } = initData
  const titleDic = t('page:sitemaps.tabs')
  const titleKeys = Object.keys(titleDic)
  const titles = Object.values(titleDic)
  const hrefs = titleKeys.map(type => h.path.sitemaps({ type, page: 0 }))
  const title = titleDic[type]

  const renderTabs = () => titles.map((tab, idx) => (
    <div key={ idx } className={ cn('px-1 py-4 mr-5', { 'border-b-2 border-black': tab === title }) }>
      <C.Link href={ hrefs[idx] } noUnderline className='text-gray-800'>{ tab }</C.Link>
    </div>
  ))

  const renderLinks = () => links.map((link, idx) => (
    <div key={ idx } className='w-1/2 sm:w-1/4 p-3'>
      <C.Link href={ link.url } className='text-gray-800'>{ link.title }</C.Link>
    </div>
  ))

  const renderPagination = () => {
    if (pageCount <= 1) return
    return (
      <div>
        <Title>{ t('common:more') }{ title }</Title>
        <div className='flex flex-wrap'>
          { range(0, pageCount - 1).map(page => (
            <div key={ page } className='w-12 p-3'>
              <C.Link href={ h.path.sitemaps({ type, page }) } className='text-gray-800'>{ page }</C.Link>
            </div>)) }
        </div>
      </div>
    )

  }
  return (
    <div className='container mb-12'>
      <div className='flex flex-wrap pt-3 border-b'>
        { renderTabs() }
      </div>
      <div className='my-5'>
        <Title>{ title }</Title>
        <div className='flex flex-wrap'>
          { renderLinks() }
        </div>
      </div>
      { renderPagination() }
    </div>
  )
}

const Title = ({ children }) => (
  <div className='px-1 py-5 font-medium text-[1.5rem]'>
    {children}
  </div>
)